export default __webpack_public_path__ + "img/2a0cfd194d6edbe4c8887e635362384f.png";